import { render, staticRenderFns } from "./pink-palace-landing.vue?vue&type=template&id=7aeb005c&"
import script from "./pink-palace-landing.vue?vue&type=script&lang=js&"
export * from "./pink-palace-landing.vue?vue&type=script&lang=js&"
import style0 from "./pink-palace-landing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports